module.exports = __webpack_public_path__ + "img/795.7f3d2ca4.jpg";